module.exports = __webpack_public_path__ + "static/offer-m-4-d5fecfad6e1e30299e5b4066ced00fc2.jpg";